import React from "react";

function Kramer() {
    return(
        <h1>
        This is the kramer page</h1>
    );
}

export default Kramer